/**
 * Shared Joyride styles and helpers used by all product tour components.
 * Change once here — applies everywhere.
 */
export const TOUR_STYLES = {
  options: {
    primaryColor: '#1D9E75',
    textColor: '#1e293b',
    backgroundColor: '#ffffff',
    arrowColor: '#ffffff',
    zIndex: 10000,
  },
  beacon: {
    display: 'none',
  },
  beaconInner: {
    display: 'none',
  },
  beaconOuter: {
    display: 'none',
  },
  tooltip: {
    borderRadius: '12px',
    padding: '20px',
  },
  tooltipTitle: {
    fontSize: '16px',
    fontWeight: '700',
    marginBottom: '8px',
  },
  tooltipContent: {
    fontSize: '14px',
    lineHeight: '1.6',
  },
  buttonNext: {
    backgroundColor: '#3b82f6',
    color: '#ffffff',
    borderRadius: '8px',
    padding: '8px 16px',
    fontSize: '14px',
    fontWeight: '600',
    border: 'none',
  },
  buttonBack: {
    backgroundColor: 'transparent',
    color: '#64748b',
    borderRadius: '8px',
    padding: '8px 16px',
    fontSize: '14px',
    border: 'none',
  },
  buttonSkip: {
    backgroundColor: 'transparent',
    color: '#94a3b8',
    fontSize: '13px',
    border: 'none',
  },
  buttonClose: {
    color: '#94a3b8',
  },
};

export const TOUR_LOCALE = {
  back: 'Back',
  close: 'Close',
  last: 'Finish',
  next: 'Next',
  skip: 'Do not show again',
};
